import { connect } from 'react-redux';
import {
  getAppointmentsViewData,
  createAppointmentRequest
} from 'state/actions/actions';
import withLocalLoader from 'components/HOCs/withLocalLoader';
import CarrierAppointments from 'tailwind-components/CarrierAppointments/CarrierAppointments';

function mapStateToProps({ user }) {
  return {
    user: user.zohoData
  };
}

export default connect(mapStateToProps, {
  getAppointmentsViewData,
  createAppointmentRequest
})(
  withLocalLoader(
    CarrierAppointments,
    true,
    'My Appointments',
    'My Appointments'
  )
);
